/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Altkonigschule2Inputs */

const en__field__enum_schoolname_altkonigschule2 = /** @type {(inputs: _Field__Enum_Schoolname_Altkonigschule2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kronberg`)
};

const de__field__enum_schoolname_altkonigschule2 = /** @type {(inputs: _Field__Enum_Schoolname_Altkonigschule2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altkönigschule`)
};

/**
* | output |
* | --- |
* | "Kronberg" |
*
* @param {_Field__Enum_Schoolname_Altkonigschule2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_altkonigschule2 = /** @type {((inputs?: _Field__Enum_Schoolname_Altkonigschule2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Altkonigschule2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_altkonigschule2(inputs)
	return de__field__enum_schoolname_altkonigschule2(inputs)
});
export { _field__enum_schoolname_altkonigschule2 as "_field__enum_schoolName_Altkonigschule" }